export default __webpack_public_path__ + "static/media/minotaur.5ed43fd6.md";